export const studentAttendance= [
    {
        admissionNo: "STU0001",
        rollNo: 35013,
        name: "Janet",
        class: "Year 3" ,
        section: "Jupiter" ,
        img : "assets/img/students/student-01.jpg",
        notes: "",
        attendance:"",
        present:"true",
        Late:"",
        Absent:"",
        Holiday:"",
        Halfday:"",
        key:1
    },
    {
        admissionNo: "STU0002",
        rollNo: 35012,
        name: "Joann",
        class: "Year 4" ,
        section: "Mars" ,
        img : "assets/img/students/student-02.jpg",
        notes: "",
        attendance:"",
        present:"true",
        Late:"",
        Absent:"",
        Holiday:"",
        Halfday:"",
        key:2
    },
    {
        admissionNo: "STU0003",
        rollNo: 35011,
        name: "Kathleen",
        class: "Year 2" ,
        section: "Jupiter" ,
        notes: "",
        attendance:"",
        present:"true",
        Late:"",
        Absent:"",
        Holiday:"",
        Halfday:"",
        img : "assets/img/students/student-03.jpg",
        key:3
    },
    {
        admissionNo: "STU0004",
        rollNo: 35010,
        name: "Gifford",
        class: "Year 1" ,
        section: "Mars" ,
        notes: "",
        attendance:"",
        present:"1",
        Late:"true",
        Absent:"",
        Holiday:"",
        Halfday:"",
        img : "assets/img/students/student-04.jpg",
        key:4
    },
    {
        admissionNo: "STU0005",
        rollNo: 35009,
        name: "Lisa",
        class: "Year 2" ,
        section: "Mars" ,
        notes: "",
        attendance:"",
        present:"1",
        Late:"",
        Absent:"",
        Holiday:"true",
        Halfday:"",
        img : "assets/img/students/student-05.jpg",
        key:5
    },
    {
        admissionNo: "STU0006",
        rollNo: 35008,
        name: "Ralph",
        class: "Year 2" ,
        section: "Mars" ,
        notes: "",
        img : "assets/img/students/student-06.jpg",
        attendance:"",
        present:"1",
        Late:"",
        Absent:"",
        Holiday:"",
        Halfday:"true",
        key:6
    },
    {
        admissionNo: "STU0007",
        rollNo: 35007,
        name: "Julie",
        class: "Year 5" ,
        section: "Jupiter" ,
        notes: "",
        img : "assets/img/students/student-07.jpg",
        attendance:"",
        present:"",
        Late:"true",
        Absent:"",
        Holiday:"",
        Halfday:"",
        key:7
    },
    {
        admissionNo: "STU0008",
        rollNo: 35006,
        name: "Ryan",
        class: "Year 6" ,
        section: "Jupiter" ,
        notes: "",
        img : "assets/img/students/student-08.jpg",
        attendance:"",
        present:"true",
        Late:"",
        Absent:"",
        Holiday:"",
        Halfday:"",
        key:8
    },
    {
        admissionNo: "STU0009",
        rollNo: 35005,
        name: "Susan",
        class: "Year 8",
        section: "Mars" ,
        notes: "",
        img : "assets/img/students/student-09.jpg",
        attendance:"",
        present:"",
        Late:"",
        Absent:"",
        Holiday:"",
        Halfday:"",
        key:9
    },
    {
        admissionNo: "STU0010",
        rollNo: 35004,
        name: "Richard",
        class: "Year 7" ,
        section: "Mars" ,
        notes: "",
        img : "assets/img/students/student-07.jpg",
        attendance:"",
        present:"1",
        Late:"",
        Absent:"",
        Holiday:"",
        Halfday:"",
        key:10
    }
];
